import { format, utcToZonedTime } from 'date-fns-tz';
import type { IntlShape } from '@atlassian/jira-intl/src/index.tsx';
import {
	TIME_SCALE_TO_LABEL_FORMAT_MAP,
	TIME_SCALE_TO_ACCESS_POINT_FORMAT_MAP,
	TIME_SCALE_TO_EXPANDED_FORMAT_MAP,
	ISO_DATE_FORMAT,
} from '../constants';

const formatDateWithInternationalisation = (
	intl: IntlShape,
	utcTimestamp: number,
	timezone: string,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	formatOps: any,
) => {
	const options = { ...formatOps, timeZone: timezone };
	return intl.formatDate(utcTimestamp, options);
};

export const getLabel = (
	utcTimestamp: number,
	timezone: string,
	searchQueryString: string,
	intl: IntlShape,
) => {
	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 1: { readonly weekday: "short"; readonly hour: "numeric"; readonly hour12: true; }; readonly 2: { readonly day: "numeric"; readonly month: "short"; }; readonly 3: { readonly day: "numeric"; readonly month: "short"; }; ... 8 more ...; readonly "9m": { ...; }; }'.
	const formatType = TIME_SCALE_TO_LABEL_FORMAT_MAP[searchQueryString];
	return formatDateWithInternationalisation(intl, utcTimestamp, timezone, formatType);
};

export const getMetaData = (
	utcTimestamp: number,
	timezone: string,
	searchQueryString: string,
	intl: IntlShape,
) => {
	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 1: { readonly weekday: "long"; readonly hour: "numeric"; readonly hour12: true; }; readonly 2: { readonly weekday: "long"; readonly day: "numeric"; readonly month: "long"; readonly year: "numeric"; }; ... 9 more ...; readonly "9m": { ...; }; }'.
	const formatType = TIME_SCALE_TO_ACCESS_POINT_FORMAT_MAP[searchQueryString];
	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 1: { readonly day: "numeric"; readonly month: "short"; readonly year: "numeric"; readonly hour: "numeric"; readonly minute: "numeric"; readonly hour12: true; }; readonly 2: { readonly day: "numeric"; readonly month: "short"; readonly year: "numeric"; }; ... 9 more ...; readonly "9m": { ...; }; }'.
	const expandedFormatType = TIME_SCALE_TO_EXPANDED_FORMAT_MAP[searchQueryString];
	return {
		formattedDate: `${formatDateWithInternationalisation(
			intl,
			utcTimestamp,
			timezone,
			formatType,
		)}`,
		expandedDate: `${formatDateWithInternationalisation(
			intl,
			utcTimestamp,
			timezone,
			expandedFormatType,
		)}`,
	};
};

export const formatDateISO = (utcTimestamp: string, timezone: string) =>
	format(utcToZonedTime(utcTimestamp, timezone), ISO_DATE_FORMAT, { timeZone: timezone });
